import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VoyageModel } from '@data-layer/models/lcl';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-lcl-select-voyage',
  templateUrl: './lcl-select-voyage.component.html',
  styleUrls: ['./lcl-select-voyage.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclSelectVoyageComponent {
  @Input() public voyage: VoyageModel;
  @Input() public voyageIdControl: UntypedFormControl;
  @Input() public isVoyageChanged: boolean;

  public formatDateTime: string = 'MM/dd/yyyy';

  public get isItemsSelected(): boolean {
    return this.voyageIdControl.value === this.voyage.id;
  }
}
